/**
 * frontend/src/pages/valuation/_CompanyStartedBlock.tsx
 *
 * VAL-PATH-COMPANY (P3) — what was chosen when the engagement was started,
 * shown read-only on step 1 (D7: subject company, period, industry and
 * deliverable are set once at creation). No input here, by design.
 */
import type { EngagementWithCompany } from '@/types/valuationCompany'
import { useValuationEntitlement, valueKindLabel } from './_shared'

/** Owner-approved (OWNER_APPROVALS.log 10-21 22:49). */
export const SET_WHEN_STARTED = 'Set when you started'

export function CompanyStartedBlock({ engagement }: { engagement: EngagementWithCompany }) {
  // JOIN-MDEMO 3d: R3 plain words for the seller only (OWNER_APPROVALS.log 2026-10-26 05:36); staff keep today's text.
  const { role } = useValuationEntitlement()
  const rows: Array<{ label: string; value: string }> = [
    { label: 'Subject company', value: engagement.subject_company_name },
    { label: 'Period', value: engagement.period_label ?? 'Not set' },
    { label: 'Industry', value: engagement.industry_label ?? engagement.industry ?? 'Not set' },
    { label: role === 'valuation_owner' ? 'What you will receive' : 'Deliverable (SSVS No. 1)', value: valueKindLabel(engagement.value_kind) },
  ]
  return (
    <section aria-labelledby="set-when-started" className="rounded-lg border border-pal-line bg-pal-surface-subtle p-4">
      <h2 id="set-when-started" className="text-sm font-semibold text-pal-ink">{SET_WHEN_STARTED}</h2>
      <dl className="mt-3 grid gap-3 sm:grid-cols-2">
        {rows.map(r => (
          <div key={r.label} className="min-w-0">
            <dt className="text-xs text-pal-ink-muted">{r.label}</dt>
            <dd className="break-words text-sm text-pal-ink">{r.value}</dd>
          </div>
        ))}
      </dl>
      <p className="mt-3 text-xs text-pal-ink-muted">Set once at engagement creation — not editable here.</p>
    </section>
  )
}
